package floris.graphics.models.dto.requests.techstack

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertTechstack(
    val name: String = "",
    @SerialName("parent_techstack_id")
    val parentTechstackId: String? = null
) {
    // With the insert, the parentTechstackId is not mandatory, so should not be checked
    val isValid get() = name.isNotBlank()
}
